import { useState, useEffect, useRef } from 'react';

import video from '../../../videos/dispositivos.mp4';
import Button from '../../elements/buttons/Button';
import n from '../../../images/s.svg';

function HeroDispositivos() {

    const [show,setShow]= useState(false);

    return (

    <section className="HeroDispositivos">
        <div className="wrap">
            <h1 className="titles">Streaming sin límites</h1>
            <p>Lleva todo el contenido a donde quiera que vayas.</p>
            <Button copy="Pruébalo gratis" link="/" className="button button-solid-grad-pink button-icon" />
        </div>
        <img src={n} className="n"/>
        <video playsInline autoPlay muted loop  id="DispositivosVideo">
            <source src={video} type="video/mp4" />
        </video>
    </section>

  )
}

export default HeroDispositivos